import { FaInstagram, FaFacebook, FaLinkedin, FaYoutube, FaTwitter, FaWhatsapp } from "react-icons/fa";

export default function Footer() {
    return (
        <footer className="bg-gray-50 py-10 px-6 max-w-[400px] md:px-16 min-h-fit">
            <div className="max-w-6xl mx-auto">
                {/* Logo */}
                <div className="mb-6">
                    <img src='/assets/img/Footer logo.png' alt='digitmoney logo' loading='lazy' className='w-[142px] h-[24px]' />
                </div>

                {/* Disclaimer */}
                <div className="mb-8">
                    <h2 className="font-bold font-atkinson text-[10px] mb-2">Disclaimer</h2>
                    <p className="text-gray-600 text-[8px] font-atkinson  leading-[11px]">


                        This site is free service for customers and provides useful information about financial products and services, tools, news and summary about popular financial products and services. We are not an Financial services company, bank, NBFC, Insurers, brokers, aggregators, direct selling agent, agent, registered advisors and do not solicit, advise or sell any financial products.
                        In case use decides to connect directly with any advertiser or brands listed through this website for their individual requirements and/or quotes, we request the users to check that the providers have necessary license required by their industry regulators to offer services in India. This site does not warrant or guarantee any price, quality, service or offer listed. It is the responsibility of the user to verify details of the service provider before they decide to enter into any transaction with them.

                    </p>
                </div>

                {/* Contact */}
                <div className="mb-6">
                    <p className="text-[12px] font-atkinson-semibold font-bold  text-[#363636]">
                        Contact us at{" "}
                        <a
                            href="mailto:hello@digitmoney.in"
                            className="font-semibold text-green-500"
                        >
                            hello@digitmoney.in
                        </a>
                    </p>
                    <div className="flex items-center gap-4 mt-3 text-gray-400 text-xl">
                        <FaFacebook />
                        <FaInstagram />
                        <FaLinkedin />
                        <FaYoutube />
                        <FaTwitter />
                        <FaWhatsapp />
                    </div>
                </div>

                {/* Links */}
                <div className="border-t border-b border-gray-200 pt-3 pb-3 mb-2 flex flex-col md:flex-row md:justify-between md:items-center gap-3">
                    <div className="flex flex-col gap-2 text-[12px] font-atkinson text-[#818181]">
                        <a href="#">Terms & Conditions</a>
                        <a href="#">Privacy Policy</a>
                    </div>
                   
                </div>
                 <p className="text-[11px] font-atkinson text-gray-500">
                        © 2025, DigitMoney Technologies Pvt. Ltd. All Rights Reserved.
                    </p>
            </div>
        </footer>
    );
}
